/**
 * Created by
 * @author <yunishev@sotal.tv> Art Yunishev
 * on 04.07.2016.
 */

/**
 *
 * @type {{asset_id: number}}
 */
export const WS_ADD_FAVORITE = 'ws-' + lh.common.events.EVENT_FAVORITE_ADD;
export const WS_REMOVE_FAVORITE = 'ws-' + lh.common.events.EVENT_FAVORITE_REMOVE;

/**
 *
 * @type {{recording_id: number}}
 */
export const WS_ADD_RECORD = 'ws-' + lh.common.events.EVENT_RECORD_ADD;
export const WS_UPDATE_RECORD = 'ws-' + lh.common.events.EVENT_RECORD_UPDATE;
export const WS_REMOVE_RECORD = 'ws-' + lh.common.events.EVENT_RECORD_REMOVE;

/**
 * @type {undefined}
 */
export const WS_OPEN_CONNECTION = 'ws-' + lh.common.events.EVENT_OPEN_CONNECTION;
export const WS_CLOSE_CONNECTION = 'ws-' + lh.common.events.EVENT_CLOSE_CONNECTION;


/**
 * @type {undefined}
 */
export const WS_INCOMING_SHARING_REQUEST = 'ws-' + lh.common.events.EVENT_INCOMING_SHARING_REQUEST;



// WEBPACK FOOTER //
// ./src/actions/ws/actions-ws.js